export enum Controller {
	AgentCall = "me/call",
	Account = "me/account",
	VoiceQueues = "me/voice/queues",
	MessagingQueues = "me/messaging/queues",
	Contacts = "me/contacts",
	ContactsAgents = "me/contacts/agents",
	CustomerHistory = "history/customer",
	Deployments = "deployments",
	Token = "tokens",
	Tenants = "tenants",
	Presence = "me/presence",
	Generics = "me/generics",
	Interactions = "me/interactions",
	SupervisedInteractions = "me/supervisedInteractions",
	Settings = "settings",
	TransferDestinations = "transfer-destinations",
	AgentPermissions = "me/permissions",
	History = "me/history",
	Supervisor = "supervisors",
	SupervisorVoice = "supervisors/voice",
	SupervisorMessaging = "supervisors/messaging",
	Emails = "me/emails",
	Voicemails = "me/voicemails",
	Messaging = "me/messaging",
	CustomerHistoryInteractions = "history/customer/interactions",
	Agents = "agents",
	MessagingTemplates = "messaging/templates",
	VoiceTemplates = "voice/templates",
	MessagingQueueTemplates = "messaging/queue/template",
	VoiceQueueTemplates = "voice/queue/template",
	Media = "media",
	MediaVoice = "media/voice",
	WhatsApp = "me/whatsapp",
	HistoryEmails = "me/history/emails",
	Webchat = "me/webchat",
	QueueSettings = "queues",
	MessagingQueueSettings = "messaging/queues",
	TranscriptionLanguages = "transcription-languages",
	AicLocking = "aic-locking",
}
